import {SPECS as SdkSpecs} from '@wix/wixstores-client-storefront-sdk/dist/es/src/constants';

export const SPECS = {
  ...SdkSpecs,
  SUBSCRIPTION_PLAN_USE_TPA_RADIO_BUTTON: 'specs.stores.SubscriptionPlanUseTpaRadioButton',
  USE_LIGHTBOXES: 'specs.stores.UseLightboxes',
  EDITOR_OOI: 'specs.stores.EditorGalleryOOI',
  DISABLE_MOBILE_NATIVE_DROPDOWN: 'specs.stores.DisableMobileNativeDropdown',
  FIX_CASHIER_PROPS_PRICE_SHIFTING: 'specs.stores.ProductPageFixCashierPropsPriceShifting',
  SHOULD_USE_COMMON_DISCOUNT_PRICING_METHODS: 'specs.stores.ShouldUseCommonDiscountPricingMethods',
  LOCATION_ONCHANGE_PATH_CHANGE_FOR_EDITOR_SAUSAGE:
    'specs.stores.ProductPageLocationOnChangePathChangeForEditorSausage',
  PRODUCT_PAGE_MIGRATE_TO_RICO_DESCRIPTION: 'specs.stores.ProductPageMigrateToRicoDescription',
  NotifyEmailOnCheckout: 'specs.stores.ProductPageNotifyEmailOnCheckout',
  SHOULD_RESET_QUANTITY_UPON_SELECTION_CHANGE: 'specs.stores.GalleryProductItemResetQuantityUponSelectionChange',
  PRODUCT_PAGE_SLOTS: 'specs.stores.ProductPageSlots',
  PRODUCT_PAGE_NEW_WIX_CODE_API: 'specs.stores.ProductPageNewWixCodeApi',
  BREADCRUMBS_AFTER_HYDRATION: 'specs.stores.ProductPageBreadcrumbsAfterHydration',
  EnableDynamicSizeDefaultImage: 'specs.stores.EnableDynamicSizeDefaultImage',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  MainMediaWrapperAsAnchorElement: 'specs.stores.MainMediaWrapperAsAnchorElement',
  ShouldProductPageUseNewSocialIcons: 'specs.stores.ShouldProductPageUseNewSocialIcons',
  BuyNowFromEcomSdk: 'specs.stores.ProductPageBuyNowFromEcomSdk',
  SendCurrencyToExpressWidget: 'specs.ecom.SendCurrencyToExpressWidget',
  RemoveControllerFactory: 'specs.stores.RemoveControllerFactory',
  ProductPageSlotsAddMoreProps: 'specs.stores.ProductPageSlotsAddMoreProps',
  ProductPageUpliftProductOptionsViewer: 'specs.stores.ProductPageUpliftProductOptionsViewer',
  ProductPageSupportGridLayout: 'specs.stores.ProductPageSupportGridLayout',
  InfoSectionTabsTPAComponent: 'specs.stores.InfoSectionTabsTPAComponent',
  GalleryImageModalDefer: 'specs.stores.GalleryImageModalDefer',
  LoadClientConfigInController: 'specs.stores.LoadClientConfigInController',
  AllowProductPageButtonsOption: 'specs.stores.allowProductPageButtonsOption',
  ProductPageSsrInvalidationTags: 'specs.stores.ProductPageSsrInvalidationTags',
  ShowAddToCartWithSubscription: 'specs.stores.ShowAddToCartWithSubscription',
  ProductPageUpliftProductOptions: 'specs.stores.ProductPageUpliftProductOptions',
  ProductPageOOIRemoveModifiersFromProductOptions: 'specs.stores.ProductPageOOIRemoveModifiersFromProductOptions',
  AllowSalePriceDesignInViewer: 'specs.stores.AllowSalePriceDesignInViewer',
  ProductMediaNavigationDots: 'specs.stores.ProductMediaNavigationDots',
  MakeOnLoadWaitForLoaderToDisappearInExpress: 'specs.ecom.MakeOnLoadWaitForLoaderToDisappearInExpress',
  ResponsiveGalleryMigration: 'specs.stores.ResponsiveGalleryMigration',
  AllowResponsiveLayoutMaxWidth: 'specs.stores.AllowResponsiveLayoutMaxWidth',
  ProductPageFixReflowSausageNavigation: 'specs.stores.ProductPageFixReflowSausageNavigation',
  MediaSlotOnBottomForResponsiveGallery: 'specs.stores.ResponsiveLayoutMediaSlotBottom',
  ReturnCartIdNullInsteadOfDeprecatedForExpressService:
    'specs.stores.ReturnCartIdNullInsteadOfDeprecatedForExpressService',
  ProductPageConsumePublicDataFromBothScopes: 'specs.stores.ProductPageConsumePublicDataFromBothScopes',
  FixVariantIdCalculationInBuyNowFlow: 'specs.stores.FixVariantIdCalculationInBuyNowFlow',
  UseExperimentsFromPlatformFlowApi: 'specs.stores.UseExperimentsFromPlatformFlowApi',
  SwitchMainMediaSlickToSwiper: 'specs.stores.SwitchMainMediaSlickToSwiper',
};
